import React, { useRef } from "react";
import { Typography, Box, Card, Button, AppBar, Toolbar, Grid, CardMedia, CardContent, Container, Divider } from "@mui/material";
import WishForm from "./WishForm";
import Logo from "../../assets/images/SPIRNEXS Logo.png";
// import Map from "../../assets/images/Map.png";
// import Map from "../../assets/images/World Map.svg";
import Map from "../../assets/images/World Map 1.svg";
import MapEmailLinkGenerate from "../../assets/images/Map.png";
import Spirnesx_tem4 from "../../assets/images/spirnesx_tem4.png";
import Spirnesx_tem3 from "../../assets/images/spirnesx_tem3.png";
import Spirnesx_tem2 from "../../assets/images/spirnesx_tem2.png";

import BlIcon from "../../assets/images/BL Reports.png";
import ComponentImage5 from "../../assets/images/Component5.png";
import Batch from "../../assets/images/Batch-wise Reports.png";
import Costing from "../../assets/images/Costing Reports.png";
import Financial from "../../assets/images/Financial Reports.png";
import Powerful from "../../assets/images/Powerful Analytics & Reports.png";
import Product from "../../assets/images/Product Reports.png";
import Tracking from "../../assets/images/Shipment Tracking.png";
import Analysic from "../../assets/images/W - 1520.33  X  H - 1520.33.png";
import EndShipmentManagement from "../../assets/images/End-to-endShipmentManagement.png";
import EndtoEnd from "../../assets/images/End to End Shipment Management.svg";

import Fingertips from "../../assets/images/Data at Your Fingertips.png";
import Clearance from "../../assets/images/From Purchase Order to Custom Clearance.png";
import Costs from "../../assets/images/Know Your Costs.png";
import Payment from "../../assets/images/Never Miss a Payment.png";
import Arrow from "../../assets/images/Arrow logo.svg";
import { Link } from "react-router-dom";


const customStyle = {
    text: {
        // fontFamily: "Helvetica, sans-serif",
        fontFamily: "Helvetica",
        textTransform: "capitalize"

    },
    compressed: { fontWeight: 600, fontStyle: "normal" },
    bold: { fontWeight: 100, fontStyle: "normal" },
    boldItalic: { fontWeight: 700, fontStyle: "italic" },
    light: { fontWeight: 300, fontStyle: "normal" },
    oblique: { fontWeight: 400, fontStyle: "italic" },
    roundedBold: { fontWeight: 700, fontStyle: "normal" },
    regular: { fontWeight: 400, fontStyle: "normal" },
};


const Header = ({ onScrollToForm }) => {
    return (
        <AppBar position="static" sx={{
            backgroundColor: "white", boxShadow: 1, height: {
                xs: "50px !important",
                sm: "60px !important",
                md: "73px !important",
                lg: "73px !important",
                xl: "80px !important",
            },
        }}>
            <Toolbar sx={{
                display: "flex",
                justifyContent: "space-between",
                mx: {
                    xs: 2,
                    sm: 3,
                    md: "122px",
                },
                minHeight: {
                    xs: "50px !important",
                    sm: "60px !important",
                    md: "73px !important",
                    lg: "73px !important",
                    xl: "80px !important",
                },


            }}>

                <Typography variant="h6">
                    <Box
                        component="img"
                        src={Logo}
                        alt="Logo"
                        sx={{
                            width: {
                                xs: "90px",
                                sm: "90px",
                                md: "140px",
                                lg: "140px",
                                xl: "160px",
                            },
                            height: "auto",
                        }}
                    />

                </Typography>


                <Box sx={{ display: "flex", gap: 3 }}>
                    <Button variant="outlined"
                        onClick={onScrollToForm}
                        color="primary" sx={{
                            width: {
                                xs: "100px",
                                sm: "110px",
                                md: "130px",
                                lg: "140px",
                                xl: "150px",
                            },
                            fontSize: {
                                xs: "12px",
                                sm: "14px",
                                md: "14px",
                                lg: "16px",
                                xl: "18px",
                            },

                            background: "#303bf3",
                            textTransform: "capitalize",
                            color: "white",
                            "&:hover": {
                                background: "#303bf3",
                            },
                            padding: {
                                xs: 0,
                                sm: 0,
                                md: "6px 16px",
                            },
                            margin: {
                                xs: 0,
                                sm: 0,
                                md: "0",
                            },

                        }}>
                        Add Wishlist
                    </Button>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

const CustomReport = ({ icon, title, content }) => {
    return (
        <Box
            sx={{
                maxWidth: 250,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                textAlign: "left",
            }}
        >
            {/* Icon */}
            <Box
                component="img"
                src={icon}
                alt={`${title}_icon`}
                sx={{
                    width: { xs: "60px", sm: "70px", md: "80px" },
                    height: "auto",
                    display: "block",
                    mt: 1,
                    ml: 2
                }}
            />

            <CardContent sx={{ px: 2, pt: 1 }}>
                <Typography variant="subtitle1" sx={{
                    fontSize: {
                        xs: "10px",
                        sm: "10px",
                        md: "15px",
                        lg: "17px",
                        xl: "18px",
                    },
                }}>
                    <div style={{ ...customStyle.text, ...customStyle.bold, color: "#424242" }}>
                        {title}
                    </div>
                </Typography>
                <Typography sx={{ fontSize: "8px", color: "text.secondary" }}>
                    {content}
                </Typography>
            </CardContent>

            {/* Bottom Line */}
            <Box
                sx={{
                    borderBottom: "2px solid #ccc",
                    width: "100%",
                    py: "0px",
                }}
            />
        </Box>
    );
};



const WishPage = () => {
    const formRef = useRef(null);

    const handleScrollToForm = () => {
        if (formRef.current) {
            formRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
        }
    };



    return (
        <>
            <Header onScrollToForm={handleScrollToForm} />
            <Box
                sx={{
                    width: {
                        xs: "100%",
                        sm: "100%",
                        md: "100%",
                        lg: "100%",
                        xl: "100%",
                    },
                    maxWidth: "1600px",
                    margin: "0 auto",
                }}
            >

                <Box
                    sx={{
                        minHeight: "100vh",
                        // background: "linear-gradient(to bottom, #2649F1, #5E00DD )",
                        background: "linear-gradient(to bottom, #2649F1,#701ee6, #5E00DD )",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        py: 4,
                        textTransform: "capitalize",
                    }}
                >
                    <Typography
                        variant="h1"
                        sx={{
                            color: "white",
                            textAlign: "center",
                            mb: 2,
                            fontSize: {
                                xs: "16px", // 📱 extra small (mobile)
                                sm: "16px", // 📲 small (tablet)
                                md: "40px", // 💻 medium (small laptop)
                                lg: "48px", // 🖥 large (desktop)
                                xl: "56px", // 🖥️📺 extra large (big monitors)
                            },

                        }}
                    >
                        <Box component="span" sx={{ ...customStyle.text, ...customStyle.regular }}>
                            Unlock <Box component="span" sx={{ ...customStyle.text, ...customStyle.bold }}>
                                data-driven decisions
                            </Box>
                        </Box>

                        <br />
                        <Box component="span" sx={{ ...customStyle.text, ...customStyle.regular }}>
                            with advanced shipment analytics.
                        </Box>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "100%",
                                my: 1,
                            }}
                        >
                            <Box
                                component="img"
                                src={Map}
                                alt="Map"
                                sx={{
                                    width: { xs: "80%", sm: "60%", md: "70%" },
                                    height: "auto",
                                    display: "block",
                                    mixBlendMode: "luminosity",
                                    objectFit: "cover",
                                }}
                            />
                            {/* image link generate for email send disply none */}
                            <Box
                                component="img"
                                src={MapEmailLinkGenerate}
                                alt="Map"
                                sx={{
                                    width: { xs: "80%", sm: "60%", md: "70%" },
                                    height: "auto",
                                    display: "block",
                                    mixBlendMode: "luminosity",
                                    objectFit: "cover",
                                }}
                                style={{ display: "none" }}
                            />
                            {/* image link generate for email send disply none  */}

                        </Box>


                        <Box sx={{ textAlign: "center", color: "white", mt: 0, mb: 2, textTransform: "capitalize" }}>
                            <Box
                                component="span"
                                sx={{
                                    fontSize: {
                                        xs: "20px",
                                        sm: "20px",
                                        md: "40px",
                                        lg: "60px",
                                        xl: "70px",
                                    },
                                }}
                            >

                                <span
                                    style={{
                                        color: "white",
                                        ...customStyle.regular,
                                        ...customStyle.text,
                                    }}
                                >
                                    Streamline your
                                </span>

                                <div
                                    style={{
                                        color: "white",
                                        ...customStyle.bold,
                                        ...customStyle.text,
                                    }}
                                >
                                    Global trade operations
                                </div>
                            </Box>
                            <Box
                                component="span"
                                sx={{
                                    fontSize: {
                                        xs: "12px",
                                        sm: "14px",
                                        md: "16px",
                                        lg: "20px",
                                        xl: "22px",

                                    },
                                }}
                            >

                                <div
                                    style={{
                                        paddingTop: "18px",
                                        fontWeight: 300,
                                        color: "white",
                                        lineHeight: 1.6,
                                        textAlign: "center",
                                        width: "100%",
                                        mx: "auto",
                                        letterSpacing: "0px",
                                        ...customStyle.light,
                                        ...customStyle.text,
                                    }}
                                >
                                    Managing import and export documents can be a complex process, but it doesn't have to be.<br />
                                    Our platform is designed to simplify every stage of your international business, from purchase<br />
                                    order to final delivery.
                                </div>

                            </Box>
                        </Box>
                    </Typography>

                    <div ref={formRef}>
                        <WishForm />
                    </div>
                    <Grid container spacing={1}>

                        <Grid item xs={12}>
                            <Box sx={{ position: "relative", display: "flex", justifyContent: "center" }}>
                                <Box
                                    component="img"
                                    src={EndShipmentManagement}
                                    alt="Large"
                                    sx={{
                                        width: { xs: "80%", sm: "60%", md: "65%" },
                                        height: "auto",
                                        display: "block",
                                        mx: "auto",
                                        maxWidth: "100%",
                                        mixBlendMode: "luminosity",
                                        objectFit: "cover",
                                        marginRight: { xs: 0, sm: 0, md: "110px" },

                                    }}
                                />

                                <Box
                                    component="img"
                                    src={EndtoEnd}
                                    alt="Small"
                                    sx={{
                                        width: { xs: "20%", sm: "20%", md: "28%" },
                                        height: "auto",
                                        position: "absolute",
                                        top: "30%",
                                        left: { xs: "15%", sm: "10%", md: "12%" },
                                    }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                    <Box
                        sx={{
                            textAlign: "center",
                            color: "white",
                            mt: { xs: 6, md: 8 },
                            mx: "auto",
                            px: { xs: 2, md: 16 },
                            fontSize: {
                                xs: "12px",
                                sm: "14px",
                                md: "16px",
                                lg: "20px",
                                xl: "22px",
                            },

                        }}
                    >
                        <div
                            style={{
                                lineHeight: 2,
                                ...customStyle.text,
                                ...customStyle.regular,
                                paddingLeft: "50px",
                                paddingRight: "50px",
                            }}
                        >
                            Take complete control of your import and export operations. Our system
                            provides a unified dashboard to manage every document and status
                            update. From <strong>Purchase Orders (PO)</strong> and{" "}
                            <strong>Proforma Invoices (PI)</strong> to{" "}
                            <strong>Commercial Invoices (CI)</strong> and{" "}
                            <strong>Bills of Lading (BL)</strong>, you'll have all
                            the essential paperwork organized in one place. You can also track shipments
                            with real-time status updates and generate comprehensive reports for
                            every stage of the process, including customs clearance.
                        </div>

                    </Box>
                    <WishForm />
                </Box>


                {/* @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ 2nd*/}

                < Container >
                    <Grid container spacing={0}
                        sx={{ mt: { xs: 1, sm: 1, md: 12 } }}

                    >
                        <Grid item xs={6} md={6} >
                            <Box
                                sx={{
                                    py: {
                                        xs: 0,
                                        sm: 0,
                                        md: 8,
                                    },
                                    marginLeft: {
                                        xs: 0,
                                        sm: 0,
                                        md: "50px",
                                    },
                                    marginTop: {
                                        xs: 0,
                                        sm: 0,
                                        md: "25px",
                                    },
                                }}
                            >

                                <Box
                                    sx={{
                                        mb: 2,
                                        fontSize: {
                                            xs: "20px",
                                            sm: "20px",
                                            md: "40px",
                                            lg: "50px",
                                            xl: "60px",
                                        },
                                    }}
                                >

                                    <div
                                        style={{
                                            mb: 2,
                                            color: "#5E00DD",
                                            ...customStyle.text,
                                            ...customStyle.bold,
                                            lineHeight: 1.2,

                                        }}
                                    >
                                        Comprehensive <br />
                                        Financial & Document<br /> Tracking
                                    </div>
                                </Box>
                                <Box
                                    sx={{
                                        fontSize: {
                                            xs: "10px",
                                            sm: "20px",
                                            md: "25px",
                                            lg: "25px",
                                            xl: "25px",
                                        },
                                        paddingTop: { xs: 0, sm: 0, md: "70px" },
                                        paddingRight: { xs: 0, sm: 0, md: "50px" },

                                    }}
                                >
                                    <div
                                        style={{
                                            lineHeight: 1.6,
                                            color: "#4D4D4D",
                                            textTransform: "capitalize",
                                            ...customStyle.text,
                                            ...customStyle.regular,


                                        }}
                                    >
                                        Stay on top of your finances with our integrated payable and receivable
                                        management features. Track all payments and receipts tied to specific
                                        shipments, ensuring accurate accounting and a clear financial picture.
                                        Our system also provides detailed ledgers for both{" "}
                                        customers and suppliers , helping you
                                        monitor balances and transaction history effortlessly.
                                    </div>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item xs={6} md={6}>
                            <Box
                                component="img"
                                src={ComponentImage5}
                                alt="ComponentImage5"
                                sx={{
                                    width: { xs: "100%", sm: "100%", md: "90%" },
                                    height: "auto",
                                    display: "block",
                                    mx: "auto",
                                    ml: 0,

                                }}
                            />
                        </Grid>

                    </Grid >

                </Container >


                <Grid container spacing={0}>
                    <Grid item xs={12}>
                        <Box
                            component="img"
                            src={Analysic}
                            alt="Analysic"
                            sx={{
                                width: { xs: "80%", sm: "60%", md: "75%" },
                                height: "auto",
                                display: "block",
                                mx: "auto",
                                maxWidth: "100%",
                                marginTop: "50px",
                                marginBottom: "130px"
                            }}
                        />
                    </Grid>

                </Grid>

                <Box
                    sx={{
                        minHeight: "100vh",
                        background: "linear-gradient(to bottom, #2649F1,#701ee6, #5E00DD )",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        py: 0,
                        textTransform: "capitalize",
                    }}
                >
                    <WishForm />
                    <Typography
                        variant="h1"
                        sx={{
                            color: "white",
                            textAlign: "center",
                            mb: { xs: 0, sm: 0, md: 4 },
                            fontSize: {
                                xs: "32px",
                                sm: "40px",
                                md: "60px",
                                lg: "70px",
                                xl: "80px",
                            },

                        }}
                    >
                        <div style={{
                            textTransform: "capitalize",
                            ...customStyle.text,
                            ...customStyle.bold,

                        }}>
                            Simplify your global <br />trade operation
                        </div>
                    </Typography>

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            my: 1,
                        }}
                    >
                        <Box
                            component="img"
                            src={Spirnesx_tem4}
                            alt="spirnesx_tem4"
                            sx={{
                                width: { xs: "90%", sm: "90%", md: "65%" },
                                height: "auto",
                                display: "block",
                                mixBlendMode: "luminosity",
                            }}
                        />
                    </Box>

                    <Box
                        sx={{
                            paddingRight: { xs: 0, sm: 0, md: "200px" },
                            paddingLeft: { xs: 0, sm: 0, md: "200px" },
                            paddingTop: { xs: "20px", sm: "20px", md: "40px" },
                            fontSize: {
                                xs: "14px",
                                sm: "14px",
                                md: "20px",
                                lg: "25px",
                                xl: "28px",
                            },

                        }}
                    >

                        <div
                            style={{
                                color: "#FFFFFF",
                                textAlign: "center",
                                ...customStyle.regular,
                                ...customStyle.text,
                            }}
                        >
                            Managing import and export documents can be complex and time-consuming.
                            Our platform is designed to streamline your entire international business workflow,
                            from the initial purchase order to final delivery. Get a unified view of your shipments,
                            manage all your documents in one place, and gain the insights you need to grow your business.
                        </div>
                    </Box>
                    <WishForm />
                </Box>
                {/* @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ */}
                <div
                    style={{
                        backgroundColor: "#00000005",
                        minHeight: "100vh",
                        paddingTop: "30px"
                    }}>
                    <Box
                        sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "center",
                            px: { xs: 1, sm: 1, md: "75px" },
                            py: { xs: 1, sm: 1, md: "30px" },
                        }}
                    >
                        <Card

                            sx={{
                                background: "#FFFFFF 0% 0% no-repeat padding-box",
                                boxShadow: "5px 5px 50px #0000001A",
                                borderRadius: "30px",
                                opacity: 1,
                                border: "2px solid #FFFFFF",
                                width: "100%",
                                paddingTop: "20px",
                                paddingBottom: "50px",
                                paddingLeft: "50px",
                                paddingRight: "50px",
                            }}

                        >
                            <Box
                                sx={{
                                    fontSize: {
                                        xs: "15px",
                                        sm: "15px",
                                        md: "42px",
                                        lg: "55px",
                                        xl: "65px",
                                    },
                                }}
                            >

                                <div
                                    style={{
                                        color: "#752AFF",
                                        textAlign: "left",
                                        ...customStyle.text,
                                        ...customStyle.bold

                                    }}
                                >
                                    Powerful Analytics & Reports
                                </div>
                            </Box>

                            <Box
                                sx={{
                                    fontSize: {
                                        xs: "10px",
                                        sm: "8px",
                                        md: "20px",
                                        lg: "20px",
                                        xl: "20px",
                                    },
                                }}
                            >

                                <div
                                    style={{
                                        lineHeight: 1.7,
                                        color: "#424242",
                                        textAlign: "left",
                                        maxWidth: "900px",
                                        ...customStyle.text,
                                        ...customStyle.regular,
                                        textTransform: "capitalize"

                                    }}
                                >
                                    Make informed decisions with a full suite of reports and analytics.
                                    Our system provides insights into your business, including:
                                </div>
                            </Box>

                            <Grid container spacing={1}>
                                <Grid item xs={12} md={6}>
                                    <Box style={{ display: "flex", }}>
                                        <Box sx={{ display: "block", paddingTop: "20px" }}>
                                            {reportsDataLeft.map((report, index) => (
                                                <CustomReport
                                                    icon={report.icon}
                                                    title={report.title}
                                                    content={report.content}
                                                />
                                            ))}
                                        </Box>
                                        <Box sx={{ display: "block", marginLeft: "20px", marginTop: "60px" }}>
                                            {reportsDataRight.map((report, index) => (
                                                <CustomReport
                                                    icon={report.icon}
                                                    title={report.title}
                                                    content={report.content}
                                                />
                                            ))}
                                        </Box>

                                    </Box>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Box
                                        component="img"
                                        src={Powerful}
                                        alt="Powerful"
                                        sx={{
                                            width: { xs: "80%", sm: "60%", md: "95%" },
                                            height: "auto",
                                            display: "block",
                                        }}
                                    />

                                </Grid>
                            </Grid>
                        </Card>
                    </Box>
                    <br />
                </div>


                <Box
                    sx={{
                        minHeight: "100vh",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        textAlign: "center",
                        marginTop: "60px"
                    }}
                >
                    <Box sx={{
                        fontSize: {
                            xs: "20px",
                            sm: "20px",
                            md: "57px",
                            lg: "57px",
                            xl: "57px",
                        },
                    }}>
                        <div
                            style={{
                                color: "#752AFF",
                                ...customStyle.text,
                                lineHeight: "1.2",
                                ...customStyle.bold
                            }}
                        >
                            Ready to Simplify Your <br /> Import-Export Business?
                        </div>
                    </Box>
                    <Box sx={{
                        fontSize: {
                            xs: "15px",
                            sm: "15px",
                            md: "22px",
                            lg: "25px",
                            xl: "25px",
                        },
                        pb: { xs: "50px", sm: "50px", md: 0, lg: 0, xl: 0 },

                    }}>
                        <div
                            style={{
                                color: "#424242",
                                ...customStyle.text,
                                lineHeight: "1.7",
                                ...customStyle.regular,
                                paddingTop: "20px",
                                paddingRight: "20px",
                                paddingLeft: "20px",
                            }}
                        >
                            Our system is built to help you save time, reduce errors, and gain full
                            visibility into your global <br /> Trade Operations.
                        </div>
                    </Box>


                    <Container>
                        <Grid
                            container
                            spacing={0}
                            alignItems="center"
                            sx={{
                                pt: { xs: 0, sm: 0, md: 4 },
                                mt: { xs: 0, sm: 0, md: 4 },
                                px: { xs: 0, sm: 0, md: 10 },
                            }}
                        >
                            <Grid item xs={6} md={6}>
                                <Box sx={{ textAlign: { xs: "left", md: "left", textTransform: "capitalize", } }}>
                                    <Box
                                        sx={{
                                            fontSize: {
                                                xs: "15px",
                                                sm: "15px",
                                                md: "36px",
                                                lg: "40px",
                                                xl: "44px",
                                            },

                                        }}
                                    >

                                        <p
                                            style={{
                                                textAlign: "left",
                                                letterSpacing: "0px",
                                                color: "#5E00DD",
                                                margin: 0,
                                                ...customStyle.text,
                                                ...customStyle.bold,
                                            }}
                                        >
                                            From Purchase <br />
                                            Order to Custom<br />
                                            Clearance:

                                        </p>

                                        <p
                                            style={{
                                                textAlign: "left",
                                                letterSpacing: "0px",
                                                color: "#424242",
                                                margin: 0,
                                                ...customStyle.text,
                                                ...customStyle.regular,

                                            }}
                                        >
                                            We've got every <br />
                                            document covered.

                                        </p>
                                    </Box>
                                </Box>
                            </Grid>

                            <Grid item xs={6} md={6}>
                                <Box
                                    component="img"
                                    src={Clearance}
                                    alt="Clearance"
                                    sx={{
                                        width: { xs: "80%", sm: "60%", md: "99%" },
                                        height: "auto",
                                        display: "flex",
                                        objectFit: "cover",
                                        justifyContent: "center"
                                    }}

                                />
                            </Grid>
                            <Grid item xs={12} md={12}>

                                <Divider sx={{
                                    borderBottomWidth: 1,
                                    boxShadow: "0px 2px 4px rgba(0,0,0,0.3)",
                                    borderColor: "#707070",
                                    marginTop: { xs: "10px", sm: "10px", md: "100px" },
                                    marginBottom: { xs: "10px", sm: "10px", md: "100px" },

                                }} />
                            </Grid>
                            {/* @@@@@@@@@@@@@@@@@222222222222222222 */}
                            <Grid item xs={6} md={6}>
                                <Box
                                    component="img"
                                    src={Costs}
                                    alt="Costs"
                                    sx={{
                                        width: { xs: "80%", sm: "60%", md: "120%" },
                                        height: "auto",
                                        display: "flex",
                                        objectFit: "cover",
                                        justifyContent: "center"
                                    }}

                                />
                            </Grid>
                            <Grid item xs={6} md={6}>
                                <Box sx={{ textAlign: { xs: "right", md: "right", textTransform: "capitalize", } }}>
                                    <Box
                                        sx={{
                                            fontSize: {
                                                xs: "15px",
                                                sm: "15px",
                                                md: "36px",
                                                lg: "40px",
                                                xl: "44px",
                                            },

                                        }}
                                    >
                                        <p
                                            style={{
                                                textAlign: "right",
                                                letterSpacing: "0px",
                                                color: "#5E00DD",
                                                margin: 0,
                                                ...customStyle.text,
                                                ...customStyle.bold,
                                            }}
                                        >
                                            Know Your Costs:
                                        </p>
                                        <p
                                            style={{
                                                textAlign: "right",
                                                letterSpacing: "0px",
                                                color: "#424242",
                                                margin: 0,
                                                ...customStyle.text,
                                                ...customStyle.regular,

                                            }}
                                        >
                                            Detailed costing<br />
                                            reports give you<br />
                                            a clear picture of<br />
                                            Profitability.

                                        </p>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Divider sx={{
                                    borderBottomWidth: 1,
                                    boxShadow: "0px 2px 4px rgba(0,0,0,0.3)",
                                    borderColor: "#707070",
                                    marginTop: { xs: "10px", sm: "10px", md: "100px" },
                                    marginBottom: { xs: "10px", sm: "10px", md: "100px" },

                                }} />
                            </Grid>

                            {/* @@@@@@@@@@@@@@@@@3333333333333333333*/}
                            <Grid item xs={6} md={6}>
                                <Box sx={{ textAlign: { xs: "left", md: "left", textTransform: "capitalize", } }}>
                                    <Box
                                        sx={{
                                            fontSize: {
                                                xs: "15px",
                                                sm: "15px",
                                                md: "36px",
                                                lg: "40px",
                                                xl: "44px",
                                            },

                                        }}
                                    >
                                        <p
                                            style={{
                                                textAlign: "left",
                                                letterSpacing: "0px",
                                                color: "#5E00DD",
                                                margin: 0,
                                                ...customStyle.text,
                                                ...customStyle.bold,
                                            }}
                                        >
                                            Never Miss<br />
                                            a Payment:
                                        </p>
                                        <p
                                            style={{
                                                textAlign: "left",
                                                letterSpacing: "0px",
                                                color: "#424242",
                                                margin: 0,
                                                ...customStyle.text,
                                                ...customStyle.regular,

                                            }}
                                        >
                                            Stay on top of <br />
                                            all <span style={{
                                                color: "#5E00DD", ...customStyle.text,
                                                ...customStyle.bold,
                                            }}> RECEIVABLES</span> <br />
                                            and

                                            <span style={{
                                                color: "#5E00DD", ...customStyle.text,
                                                ...customStyle.bold,
                                            }}> PAYABLES.</span>

                                        </p>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={6} md={6}>
                                <Box
                                    component="img"
                                    src={Payment}
                                    alt="Payment"
                                    sx={{
                                        width: { xs: "80%", sm: "60%", md: "95%" },
                                        height: "auto",
                                        display: "flex",
                                        objectFit: "cover",
                                        justifyContent: "center"
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Divider sx={{
                                    borderBottomWidth: 1,
                                    boxShadow: "0px 2px 4px rgba(0,0,0,0.3)",
                                    borderColor: "#707070",
                                    marginTop: { xs: "10px", sm: "10px", md: "100px" },
                                    marginBottom: { xs: "10px", sm: "10px", md: "100px" },

                                }} /> </Grid>
                            {/* @@@@@@@@@@@@@@@@@4444444444444444*/}
                            <Grid item xs={6} md={6}>
                                <Box
                                    component="img"
                                    src={Fingertips}
                                    alt="Fingertips"
                                    sx={{
                                        width: { xs: "80%", sm: "60%", md: "95%" },
                                        height: "auto",
                                        display: "flex",
                                        objectFit: "cover",
                                        justifyContent: "center"
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} md={6}>
                                <Box sx={{ textAlign: { xs: "center", md: "right", textTransform: "capitalize", } }}>
                                    <Box
                                        sx={{
                                            fontSize: {
                                                xs: "15px",
                                                sm: "15px",
                                                md: "36px",
                                                lg: "40px",
                                                xl: "44px",
                                            },

                                        }}
                                    >
                                        <p
                                            style={{
                                                textAlign: "right",
                                                letterSpacing: "0px",
                                                color: "#5E00DD",
                                                margin: 0,
                                                ...customStyle.text,
                                                ...customStyle.bold,
                                            }}
                                        >
                                            Data at Your <br />
                                            Fingertips:
                                        </p>
                                        <p
                                            style={{
                                                textAlign: "right",
                                                letterSpacing: "0px",
                                                color: "#424242",
                                                margin: 0,
                                                ...customStyle.text,
                                                ...customStyle.regular,

                                            }}
                                        >
                                            Access real-time<br />
                                            reports by country,<br />
                                            port, supplier, or<br />
                                            customer.
                                        </p>
                                    </Box>
                                </Box>
                            </Grid>

                        </Grid>
                    </Container>
                    <WishForm />
                </Box >
            </Box >

        </>

    );
};

export default WishPage;

// Left side reports
const reportsDataRight = [
    {
        icon: Financial,
        title: "Financial Reports",
        content:
            "Track advance and final payments, receipts, and outstanding amounts. Our system even highlights due amounts in red to ensure you never miss a payment.",
    },
    {
        icon: BlIcon,
        title: "BL Reports",
        content:
            "Keep a master list of all Bills of Lading and easily update their status (Draft, MBL, HBL, Telex Release) as the shipment progresses.",
    },
    {
        icon: Batch,
        title: "Batch-wise Reports",
        content:
            "Track shipments and their associated documents by specific batch numbers for better inventory and quality control.",
    },
];

// Right side reports
const reportsDataLeft = [
    {
        icon: Costing,
        title: "Costing Reports",
        content:
            "See the true cost of each shipment with a detailed breakdown of expenses like freight, customs duties, and bank charges.",
    },
    {
        icon: Tracking,
        title: "Shipment Tracking",
        content:
            "View all your import and export shipments in one place, with the latest status updates at the top.",
    },
    {
        icon: Product,
        title: "Product Reports",
        content:
            "Get a clear overview of product-wise import and export quantities, with monthly reports and historical data.",
    },
];
